import React, { useEffect } from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import img1 from '../assets/imgs/m1 (1).webp';
import img2 from '../assets/imgs/m1 (2).webp';
import img3 from '../assets/imgs/m1 (3).webp';
import img4 from '../assets/imgs/m1 (4).webp';
import img5 from '../assets/imgs/m1 (5).webp';
import img6 from '../assets/imgs/m1 (6).webp';
import img7 from '../assets/imgs/m1 (7).webp';
import img8 from '../assets/imgs/m1 (8).webp';

const LeadershipTeam = () => {
    useEffect(() => {
        AOS.init({
            duration: 800, // Duration of animations
            easing: 'ease-in-out',
            once: false, // Animates only once
        });
    }, []);

    const teamMembers = [
        { name: 'Employee Name', role: 'Designation', img: img1 },
        { name: 'Employee Name', role: 'Designation', img: img2 },
        { name: 'Employee Name', role: 'Designation', img: img3 },
        { name: 'Employee Name', role: 'Designation', img: img4 },
        { name: 'Employee Name', role: 'Designation', img: img5 },
        { name: 'Employee Name', role: 'Designation', img: img6 },
        { name: 'Employee Name', role: 'Designation', img: img7 },
        { name: 'Employee Name', role: 'Designation', img: img8 },
    ];

    return (
        <section className="leadership-team-section" data-aos="fade-in">
            <h2 data-aos="fade-up">Our Leadership Team</h2>
            <p data-aos="fade-up" data-aos-delay="200">
                With over 100 years of combined experience, we've got a well-seasoned team at the helm.
            </p>
            {/* <div className="teamMembers">
                {teamMembers.map((member, index) => (
                    <div 
                        key={index} 
                        className="teamMember" 
                        data-aos="fade-up" 
                        data-aos-delay={300 + index * 100} // Cascading effect
                    >
                        <img src={member.img} loading="lazy" alt={member.name} />
                        <h3>{member.name}</h3>
                        <h4>{member.role}</h4>
                    </div>
                ))}
            </div> */}
        </section>
    );
};

export default LeadershipTeam;
